import { render, staticRenderFns } from "./ProductContentAccordianList.vue?vue&type=template&id=544e2ae6&scoped=true&"
import script from "./ProductContentAccordianList.vue?vue&type=script&lang=js&"
export * from "./ProductContentAccordianList.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentAccordianList.vue?vue&type=style&index=0&id=544e2ae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e2ae6",
  null
  
)

export default component.exports